module.exports = __webpack_public_path__ + "static/api-ec5eecc3a54ca00f71c203b44468b58b.png";